/* eslint-disable space-before-function-paren */
import Vue from 'vue'
import Router from 'vue-router'
import { VueMaskDirective } from 'v-mask'

const AppLayout = () => import('@/components/layout/AppLayout')
const Login = () => import('@/components/login/Login')
const Users = () => import('@/components/users/Users')
const Clients = () => import('@/components/clients/Clients')
const SiengeClients = () => import('@/components/clients/SiengeClients')
const SiengeCreditors = () => import('@/components/creditors/SiengeCreditors')
const FormClient = () => import('@/components/clients/FormClient')
const RealStates = () => import('@/components/realStates/RealStates')
const Properties = () => import('@/components/properties/Properties')
const SizeLots = () => import('@/components/sizeLots/SizeLots')
const Reserves = () => import('@/components/reserves/Reserves')
const Politics = () => import('@/components/politics/PrivacyPolicies')
const MyInfos = () => import('@/components/myInfos/MyInfos')
const Ops = () => import('@/components/layout/Ops')
const Configs = () => import('@/components/configs/Config')
const Professions = () => import('@/components/professions/FormProfession')
const Requests = () => import('@/components/requests/Requests')
const Dashboards = () => import('@/components/dashboards/Dashboard')
const ClientChanges = () => import('@/components/clients/ClientChanges')

Vue.directive('mask', VueMaskDirective)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const adminRole = [1]
const adminOrManagerRole = [1, 3]
const collaboratorRole = [1, 2, 3]

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/politicas-de-privacidade',
      name: 'politics',
      component: Politics
    },
    {
      path: '/ops',
      name: 'ops',
      component: Ops
    },
    {
      path: '',
      component: AppLayout,
      children: [
        {
          path: '/',
          name: 'clients',
          component: Clients,
          meta: {
            requireAuth: true,
            grants: collaboratorRole
          }
        },
        {
          path: '/graficos',
          name: 'dashboards',
          component: Dashboards,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/clientes-sienge',
          name: 'sienge-clients',
          component: SiengeClients,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/clientes/novo',
          name: 'createClient',
          component: FormClient,
          meta: {
            requireAuth: true,
            grants: collaboratorRole
          }
        },
        {
          path: '/clientes/:id/editar',
          name: 'editClient',
          component: FormClient,
          meta: {
            requireAuth: true,
            grants: collaboratorRole
          }
        },
        {
          path: '/usuarios',
          name: 'users',
          component: Users,
          meta: {
            requireAuth: true,
            grants: adminOrManagerRole
          }
        },
        {
          path: '/credores',
          name: 'sienge-creditors',
          component: SiengeCreditors,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/imobiliarias',
          name: 'realStates',
          component: RealStates,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/imoveis',
          name: 'properties',
          component: Properties,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/tamanhos',
          name: 'sizeLots',
          component: SizeLots,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/reservas',
          name: 'reserves',
          component: Reserves,
          meta: {
            requireAuth: true,
            grants: collaboratorRole
          }
        },
        {
          path: '/solicitacoes',
          name: 'requests',
          component: Requests,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/infos',
          name: 'myinfos',
          component: MyInfos,
          meta: {
            requireAuth: true,
            grants: collaboratorRole
          }
        },
        {
          path: '/configuracoes',
          name: 'configs',
          component: Configs,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/profissoes',
          name: 'professions',
          component: Professions,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        },
        {
          path: '/clientes-alterados',
          name: 'client-changes',
          component: ClientChanges,
          meta: {
            requireAuth: true,
            grants: adminRole
          }
        }
      ]
    },
    { path: '*', component: Ops }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js